const url = process.env.REACT_APP_ENV === 'production' ?
    "https://api.fudopia.com/api/v1" : "http://127.0.0.1:8000/api/v1";

export const apiRoot = url;

